import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  treatmentCard: {
    width: '100%',
    '& .ant-card-body': {
      padding: 0
    }
  },
  treatmentContent: {
    padding: '24px 24px'
  },
  tagsWrapper: {
    marginTop: 16
  },
  dropdownRender: {
    padding: 4
  },
  tags: {
    borderRadius: 16,
    padding: '4px, 10px, 4px, 12px',
    color: token.primary.primary1,
    backgroundColor: token.blue1,
    border: 'none',
    '.ant-tag-close-icon': {
      color: token.primary.primary1
    }
  }
}))
